export const updateSomethingInSomethingsArray = <T extends { id: number }>(items: T[], updated: T) =>
  items.map((oldHouse) => (oldHouse.id === updated.id && updated) || oldHouse);
